// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { getIsPageVisible, pageVisibilityChangeEventName } from '../dom/pageVisibilityUtils';

// Selectors
import { getCurrentUserId } from '../../user/currentUserSelector';

// Actions
import { userActivityHeartbeat } from '../../../common/users/userActions';

// Constants
import { USER_IDLE_TIMEOUT_MILLISECONDS } from '../../../common/users/userConstants';

const mapStateToProps = createStructuredSelector({
    currentUserId: getCurrentUserId,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchUserActivityHeartbeat: (userId) => dispatch(userActivityHeartbeat({ userId })),
});

@connect(mapStateToProps, mapDispatchToProps)
class UserActivityHeartbeat extends React.Component {
    componentWillMount() {
        this.startHeartbeatInterval();
        document.addEventListener(pageVisibilityChangeEventName, this.onVisibilityChange);
    }

    componentWillUnmount() {
        this.stopHeartbeatInterval();

        document.removeEventListener(pageVisibilityChangeEventName, this.onVisibilityChange);
    }

    onHeartbeatInterval = () => {
        const { dispatchUserActivityHeartbeat, currentUserId } = this.props;
        dispatchUserActivityHeartbeat(currentUserId);
    };

    onVisibilityChange = () => {
        getIsPageVisible()
            ? // If hidden stop the interval
              this.stopHeartbeatInterval()
            : // If showing start the interval
              this.startHeartbeatInterval();
    };

    startHeartbeatInterval = () => {
        this.heartbeatIntervalId = setInterval(this.onHeartbeatInterval, USER_IDLE_TIMEOUT_MILLISECONDS / 2);
    };

    stopHeartbeatInterval = () => {
        if (this.heartbeatIntervalId) clearTimeout(this.heartbeatIntervalId);
    };

    render() {
        return null;
    }
}

UserActivityHeartbeat.propTypes = {
    currentUserId: PropTypes.string,
    dispatchUserActivityHeartbeat: PropTypes.func,
};

export default UserActivityHeartbeat;
